import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { OnboardingActions } from "./onboarding.actions";

interface initialStateTypes {
  data: any;
  access_token: string | null | undefined;
  error: string;
  loading: boolean;
  whatsapp_data: any;
  workspace_id?: string | null;
  email?: string | null;
}

const initialState: initialStateTypes = {
  data: null,
  access_token: null,
  error: "",
  loading: false,
  whatsapp_data:[],
  workspace_id: null,
  email: null,
};

const OnboardingSlice = createSlice({
  name: "OnboardingSlice",
  initialState,
  reducers: {

    setWhatsappOnboardingConfig(state, { payload }: PayloadAction<any>) {
      state.data = payload;
    },
    setWhatsappAccessToken(state, { payload }: PayloadAction<any>) {
      state.access_token = payload;
    },
    setWorkspaceId(state, { payload }: PayloadAction<string>) {
      state.workspace_id = payload;
    },
    setEmail(state, { payload }: PayloadAction<string>) {
      state.email = payload;
    },
   
  },
  extraReducers: (builder) => {
    builder.
    addCase(OnboardingActions.updateWhatsappProfile.pending,
      (state, action) => {
        state.whatsapp_data = [];
      },
    ).addCase(
      OnboardingActions.updateWhatsappProfile.fulfilled,
      (state, action) => {
        state.whatsapp_data = action.payload?.data;
      },
    )
    .addCase(
        OnboardingActions.updateWhatsappProfile.rejected,
          (state, action) => {
              state.whatsapp_data = [];
          },
          )
  },
});

export default OnboardingSlice.reducer;

export const {
  setWhatsappOnboardingConfig,
  setWhatsappAccessToken,
  setWorkspaceId,
  setEmail,
} = OnboardingSlice.actions;
